import React, { Suspense, useState, useEffect } from 'react';
// import Keycloak from 'keycloak-js';
import axios from 'axios';
import callPostApi from "../requests/PostRequests"
import * as Constants from '../requests/URLConstants'
import queryString from 'query-string';

var config = require('./../config/appConfig.json');


const LoginPage = (props) => {
  const [loading, setLoading] = useState(true);


 useEffect(() => {
  async function fetchLoginApi(){

  //console.log('serverURL:' + config.serverUrl);
  let body;
  let params = queryString.parse(props.location.search);
  //  console.log("params",params);
   if(params && params.teamName){
    body = {
      "teamName": params.teamName     
   }
  }
  let response = await callPostApi(Constants.PREPAREURL,'',body)

  // let response = await callPostApi(Constants.PREPAREURL,'','')
  //console.log(response)
  localStorage.setItem('nonce', response.nonce)
  localStorage.setItem('state', response.state)
  localStorage.setItem('redirect', response.redirect)

  //console.log(`Response data after prepare call: ${response}`);
  setLoading(false);
 }
 fetchLoginApi();
},[])

    if (!loading) {
      let redirect_value = localStorage.getItem('redirect')
      //console.log(redirect_value);
      if (redirect_value !== null) {
        //console.log("Redirecting to keycloak with redirect_value: " + redirect_value);
        window.location.href = redirect_value;
      }
      else {
        //console.log(`inside else block!`)
        return null;
      };
    } else {
      return null;
    }
  }

export default LoginPage;